import React, { Fragment } from 'react';
import InputField from '../../Reusable/InputField';
import withTranslations from '../../../utils/HighOrderComponent';
import { Row, Col, Card } from 'react-bootstrap';
import { confirmDialog } from '../../Reusable/ConfirmDialog';
import {
  findSignetById,
  updateSignetStatus,
  updateSignetState,
  downloadAttachment,
} from '../../../actions/signet';
import { downloadExample } from '../../../actions/signetExample';
import {
  actionsSignet,
  controllerPath,
  signetStatuses,
} from '../../../constants/globals';
import { connect } from 'react-redux';
import moment from 'moment';
import { findAllUserAllowedActions } from '../../../actions/user';
import authorizationService from '../../../securityUtils/authorizationService';
import PostAddIcon from '@material-ui/icons/PostAdd';
import AssignmentLateOutlinedIcon from '@material-ui/icons/AssignmentLateOutlined';
import CreateNewFolderOutlinedIcon from '@material-ui/icons/CreateNewFolderOutlined';
import ModalForAddSubmissionDataSignet from '../ModalForAddSubmissionDataSignet';
import BeenhereRoundedIcon from '@material-ui/icons/BeenhereRounded';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';
import ImageSearch from '@material-ui/icons/ImageSearch';
import {
  createSubmissionDataSignet,
  findSubmissionDataSignetBySignetId,
  createSubmissionDataSignetWithLook,
} from '../../../actions/submissionDataSignet';
import {
  findSubmissionDataSignetDestroyedLatestVersione,
  deleteDestroyedContetnt,
  uploadSubmissionDataSignetDestroyed,
} from '../../../actions/submissionDataSignetDestroyed';
import { deleteLookContetnt } from '../../../actions/submissionDataSignetLook';
import { formatDate, getUserNameAndSurname } from '../../../utils';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import ModalForAddComplementSignet from '../ModalForAddComplementSignet';
import {
  clearComplementSignet,
  findLastComplementSignetBySignetId,
  createComplementSignet,
  findComplementSignetListBySignetId,
} from '../../../actions/complementSignet';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import AttachmentTable from '../../Reusable/AttachmentTable/AttachmentTable';
import ModalForAddRequestForSignetStatus from '../ModalForAddRequestForSignetStatus';
import {
  createRequestForSignetStatus,
  validateRequestForSignetStatus,
  findRequestForSignetStatusBySignetId,
} from '../../../actions/requestForSignetStatus';
import ModalForPreviewRequestApproval from '../ModalForPreviewRequestApproval';
import ModalForUploadSignetDestroyedAttachment from '../ModalForUploadSignetDestroyedAttachment';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ActionButton from '../../Reusable/ActionButton';
import HistoryRoundedIcon from '@material-ui/icons/HistoryRounded';
import ModalForViewComplementSignetHistory from '../ModalForViewComplementSignetHistory';

class SignetProcessingView extends React.Component {
  constructor() {
    super();
    this.state = {
      showSubmissionDataSignet: false,
      showComplementSignet: false,
      showComplementSignetDesc: false,
      showRequestForSignetStatus: false,
      showRequestForSignetApprovalPreview: false,
      showModalForSignetDestroyedAttachment: false,
      showComplementSignetHistory: false,
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.findSignetById(id);
    this.props.findSubmissionDataSignetBySignetId(id);
    this.props.findRequestForSignetStatusBySignetId(id);
    this.props.findComplementSignetListBySignetId(id);
    this.handleGetUserAllowedActions();
  }

  componentWillUnmount() {
    this.props.deleteLookContetnt();
    this.props.deleteDestroyedContetnt();
  }

  showModal = (signal) => {
    switch (signal) {
      case 1:
        this.setState({ showModalUpdateSignetState: true });
        break;
      case 2:
        this.setState({ showSubmissionDataSignet: true });
        break;
      case 4:
        this.setState({ showComplementSignet: true });
        break;
      case 5:
        this.setState({ showComplementSignetDesc: true });
        break;
      case 6:
        this.setState({ showRequestForSignetStatus: true });
        break;
      case 7:
        this.setState({ showRequestForSignetApprovalPreview: true });
        break;
      case 8:
        this.setState({ showModalForSignetDestroyedAttachment: true });
        break;
      case 9:
        this.setState({ showComplementSignetHistory: true });
        break;
      default:
        break;
    }
  };

  isModalOpened = () => {
    this.props.isModalOpened(this.state.showUpdate);
  };

  showServerError = (isModalOpened) => {
    return isModalOpened ? false : true;
  };

  handlePreviewClose = () => {
    const { id } = this.props.match.params;
    this.setState({
      showSubmissionDataSignet: false,
      showComplementSignet: false,
      showComplementSignetDesc: false,
      showRequestForSignetStatus: false,
      showRequestForSignetApprovalPreview: false,
      showModalForSignetDestroyedAttachment: false,
      showComplementSignetHistory: false,
    });
    //this.props.deleteError();
    this.props.findSignetById(id);
    this.props.clearComplementSignet();
    this.props.findSubmissionDataSignetBySignetId(id);
    this.handleGetUserAllowedActions();
  };

  handleAdd = (submissionDataSignet) => {
    const messages = this.props.t.NotificationMessages;
    this.props.createSubmissionDataSignet(
      submissionDataSignet,
      this.handlePreviewClose,
      messages
    );
  };

  handleUpdateSignetStatus = (status) => {
    const { id } = this.props.match.params;
    const { ConfirmDialog, NotificationMessages } = this.props.t || {};
    const action = () => {
      this.props.updateSignetStatus(
        id,
        status,
        this.handleGetUserAllowedActions,
        NotificationMessages
      );
    };
    let confirmMessage = '';
    switch (status) {
      case signetStatuses.FINISHED.name:
        confirmMessage = ConfirmDialog.confirmApproveMessage;
        break;
      case signetStatuses.REJECTED.name:
        confirmMessage = ConfirmDialog.confirmRejectMessage;
        break;
      default:
        break;
    }

    confirmDialog(confirmMessage, action, '', this.props.gt);
  };

  handleAddWithLook = (submissionDataSignet, signetStatus) => {
    this.props.createSubmissionDataSignetWithLook(
      submissionDataSignet,
      this.handlePreviewClose,
      this.props.t.NotificationMessages,
      this.props.enums.SignetStatus,
      signetStatus
    );
  };

  handleUploadSignetDestroyedAttachment = (data) => {
    const { submissionDataSignet } = this.props.submissionDataSignet;
    this.props.uploadSubmissionDataSignetDestroyed(
      data,
      submissionDataSignet?.id,
      this.handlePreviewClose,
      this.props.t.NotificationMessages
    );
  };

  handleAddComplementSignet = (complementSignet) => {
    const messages = this.props.t.NotificationMessages;
    this.props.createComplementSignet(
      complementSignet,
      this.handlePreviewClose,
      messages
    );
    this.showServerError(this.state.showComplementSignet);
  };

  handleAddRequestForSignetStatus = (requestForSignetStatus) => {
    const { id } = this.props.match.params;
    const messages = this.props.t.NotificationMessages;
    this.props.createRequestForSignetStatus(
      requestForSignetStatus,
      this.handlePreviewClose,
      () => this.props.findAllUserAllowedActions(id, controllerPath.SIGNET),
      messages,
      () => this.props.findRequestForSignetStatusBySignetId(id)
    );
  };

  acceptRequestForSignetStatus = () => {
    const { id } = this.props.match.params;
    const { ConfirmDialog, NotificationMessages } = this.props.t || {};
    const action = () => {
      this.props.validateRequestForSignetStatus(
        this.props.requestForSignetStatus?.id,
        this.handleGetUserAllowedActions,
        NotificationMessages,
        () => this.props.findRequestForSignetStatusBySignetId(id)
      );
    };

    confirmDialog(
      ConfirmDialog.confirmAcceptRequestForSignetStatus,
      action,
      '',
      this.props.gt
    );
  };

  acceptComplementedChange = () => {
    const { id } = this.props.match.params;
    const { ConfirmDialog, NotificationMessages } = this.props.t || {};
    const action = () => {
      this.props.updateSignetStatus(
        id,
        signetStatuses.COMPLEMENTED.name,
        this.handleGetUserAllowedActions,
        NotificationMessages
      );
    };

    confirmDialog(
      ConfirmDialog.confirmComplementedMessage,
      action,
      '',
      this.props.gt
    );
  };

  downloadSignetExample = () => {
    const messages = this.props.t.NotificationMessages;
    this.props.downloadExample(messages);
  };

  handleGetUserAllowedActions = () => {
    const { id } = this.props.match.params;
    this.props.findAllUserAllowedActions(id, controllerPath.SIGNET);
  };

  render() {
    const {
        signet,
        enums,
        t,
        submissionDataSignetDestroyed,
        submissionDataSignetLook,
        userAllowedActionsList,
        downloadAttachment,
        requestForSignetStatusAttachment,
        complementSignetList,
        errorComplement,
      } = this.props || {},
      {
        plannedStart,
        statusChangedDate,
        decision,
        uniqueSerialNumber,
        validUntil,
        beginOfUsage,
      } = signet || {},
      { requestForSignetApproval } = decision || {},
      { referenceNumber, kjsMunicipality, client } =
        requestForSignetApproval || {},
      { kjs } = kjsMunicipality || {},
      { SignetStatus, SignetState } = enums || {},
      { Placeholders, Tooltips } = t || {};

    const currentDate = moment(new Date()).toDate();
    const plannedStartFormat = moment(beginOfUsage).toDate();
    const daysUntilStart = moment(currentDate).diff(
      moment(plannedStartFormat),
      'days'
    );
    const numberOfDaysUntilStart = '' + (Math.abs(daysUntilStart) + 1);

    let numberOfDaysUntilStartText = t.Placeholders.days;
    if (
      numberOfDaysUntilStart === '1' ||
      (numberOfDaysUntilStart.endsWith('1') &&
        !numberOfDaysUntilStart.endsWith('11'))
    ) {
      numberOfDaysUntilStartText = t.Placeholders.day;
    }
    const { submissionDataSignetDestroyedAttachment } =
      submissionDataSignetDestroyed || {};
    const { submissionDataSignetLookAttachment } =
      submissionDataSignetLook || {};

    const status = SignetStatus[signet.signetStatus]?.text;
    const signetState = SignetState[signet.signetState]?.text;
    const statusChangeDate = statusChangedDate && formatDate(statusChangedDate);
    const plannedStartDate = plannedStart && formatDate(plannedStart);
    const validUntilDate = validUntil && formatDate(validUntil);
    const beginOfUsageDate = beginOfUsage && formatDate(beginOfUsage);

    const authorizedPerson = getUserNameAndSurname(client);

    const isCreateSubmissioDataAllowed = authorizationService.isActionAllowed(
      actionsSignet.SUBMISSION_DATA_SIGNET_CREATE,
      userAllowedActionsList
    );

    const isCreateComplementSubmissioDataAllowed =
      authorizationService.isActionAllowed(
        actionsSignet.COMPLEMENT_SIGNET_CREATE,
        userAllowedActionsList
      );

    const isUpdateSubmissioDataAllowed = authorizationService.isActionAllowed(
      actionsSignet.SUBMISSION_DATA_SIGNET_UPDATE,
      userAllowedActionsList
    );

    const isAcceptSubmissioDataAllowed = authorizationService.isActionAllowed(
      actionsSignet.ACCEPT_SUBMISSION_DATA_SIGNET,
      userAllowedActionsList
    );

    const isRequestForSignetStatusCreateAllowed =
      authorizationService.isActionAllowed(
        actionsSignet.REQUEST_FOR_SIGNET_STATUS_CREATE,
        userAllowedActionsList
      );

    const isRequestForSignetStatusValidateAllowed =
      authorizationService.isActionAllowed(
        actionsSignet.VALIDATE_REQUEST_FOR_SIGNET_STATUS,
        userAllowedActionsList
      );

    const isSignetExampleDownloadAllowed = authorizationService.isActionAllowed(
      actionsSignet.DOWNLOAD_EXAMPLE_SIGNET,
      userAllowedActionsList
    );

    const colorOfPostAddIcon =
      isUpdateSubmissioDataAllowed ||
      signet.signetStatus === signetStatuses.APPROVED.name
        ? '#a9454f'
        : '#203a5d';

    const messageOfPostAddIcon =
      signet.signetStatus === signetStatuses.COMPLEMENT_REQUIRED.name
        ? Tooltips.updateComplementSignet
        : Tooltips.complementSignet;

    const signetStateInfo = (
      <InputField placeholder={Placeholders.sigentState} value={signetState} />
    );

    const signetStatusInfo = (
      <InputField placeholder={Placeholders.sigentStatus} value={status} />
    );

    const requestStatusAttachment = requestForSignetStatusAttachment && [
      {
        id: requestForSignetStatusAttachment.id,
        embeddableAttribute: {
          name: requestForSignetStatusAttachment.embeddableAttribute?.name,
          uuidName:
            requestForSignetStatusAttachment.embeddableAttribute?.uuidName,
          mimeType:
            requestForSignetStatusAttachment.embeddableAttribute?.mimeType,
          mimeTypeShort:
            requestForSignetStatusAttachment.embeddableAttribute?.mimeTypeShort,
          content:
            requestForSignetStatusAttachment.embeddableAttribute?.content,
        },
      },
    ];

    const attachments = submissionDataSignetLookAttachment?.id
      ? submissionDataSignetDestroyedAttachment?.id
        ? [submissionDataSignetLookAttachment].concat([
            submissionDataSignetDestroyedAttachment,
          ])
        : [submissionDataSignetLookAttachment]
      : [];

    const signetData = (
      <Row style={{ marginTop: '-20px' }}>
        <Col md={4}>
          <InputField
            name="organizationalUnit"
            placeholder={Placeholders.organizationalUnit}
            value={kjs?.name}
            disabled
          />

          <InputField
            name="authorizedPerson"
            placeholder={Placeholders.authorizedPerson}
            value={authorizedPerson}
            disabled
          />
        </Col>
        <Col md={4}>
          <InputField
            name="request"
            placeholder={Placeholders.request}
            value={referenceNumber}
            disabled
          />
          <InputField
            name="statusChangedDate"
            placeholder={Placeholders.statusChangedDate}
            value={statusChangeDate}
            disabled
          />
        </Col>
        <Col md={4}>
          <Row>
            <Col md={6}>
              <InputField
                name="uniqueSerialNumber"
                placeholder={Placeholders.uniqueSerialNumber}
                multiple={false}
                value={uniqueSerialNumber}
                disabled
              />
            </Col>
            <Col md={6}>
              <InputField
                name="beginOfUsage"
                placeholder={Placeholders.beginOfUsage}
                multiple={false}
                value={beginOfUsageDate}
                disabled
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <InputField
                name="plannedStart"
                placeholder={Placeholders.plannedStart}
                value={plannedStartDate}
                disabled
              />
            </Col>
            <Col md={6}>
              <InputField
                name="validUntil"
                placeholder={Placeholders.validUntil}
                value={validUntilDate}
                disabled
              />
            </Col>
          </Row>
        </Col>
        <Col md={5} className="mt-5 ">
          <Card>
            <Card.Header>
              <Card.Title as="h5">{t.Labels.actionTitle}</Card.Title>
            </Card.Header>
            <Card.Body>
              <Row className="action-signet-height">
                <ActionButton
                  signetSignal={true}
                  actionMessage={Tooltips.requestPreview}
                  action={() => this.showModal(7)}
                  icon={
                    <ImageSearch
                      fontSize="large"
                      style={{ color: '#203a5d' }}
                    />
                  }
                />
                {isSignetExampleDownloadAllowed && (
                  <ActionButton
                    signetSignal={true}
                    actionMessage={Tooltips.downloadExample}
                    action={this.downloadSignetExample}
                    icon={
                      <CloudDownloadOutlinedIcon
                        style={{ color: '#203a5d' }}
                        fontSize="large"
                      />
                    }
                  />
                )}
                {(isCreateSubmissioDataAllowed ||
                  isUpdateSubmissioDataAllowed) && (
                  <ActionButton
                    signetSignal={true}
                    actionMessage={messageOfPostAddIcon}
                    action={() => this.showModal(2)}
                    icon={
                      <PostAddIcon
                        style={{
                          color: colorOfPostAddIcon,
                        }}
                        fontSize="large"
                      />
                    }
                  />
                )}
                {isCreateComplementSubmissioDataAllowed && (
                  <ActionButton
                    signetSignal={true}
                    actionMessage={Tooltips.complementRequired}
                    action={() => this.showModal(4)}
                    icon={
                      <NoteAddIcon
                        fontSize="large"
                        style={{ color: '#203a5d' }}
                      />
                    }
                  />
                )}
                {isUpdateSubmissioDataAllowed && (
                  <ActionButton
                    signetSignal={true}
                    actionMessage={Tooltips.complementSignetContent}
                    action={() => this.showModal(5)}
                    icon={
                      <AssignmentLateOutlinedIcon
                        fontSize="large"
                        className="red-color"
                      />
                    }
                  />
                )}
                {isUpdateSubmissioDataAllowed && (
                  <ActionButton
                    signetSignal={true}
                    actionMessage={Tooltips.uploadSignetDestroyed}
                    action={() => this.showModal(8)}
                    icon={
                      <CloudUploadIcon
                        fontSize="large"
                        style={{ color: '#203a5d' }}
                      />
                    }
                  />
                )}
                {(isCreateSubmissioDataAllowed ||
                  isUpdateSubmissioDataAllowed) &&
                  signet.signetStatus ===
                    signetStatuses.COMPLEMENT_REQUIRED.name && (
                    <ActionButton
                      signetSignal={true}
                      actionMessage={Tooltips.acceptComplemened}
                      action={this.acceptComplementedChange}
                      icon={
                        <CheckCircleRoundedIcon
                          style={{ color: '#203a5d' }}
                          fontSize="large"
                        />
                      }
                    />
                  )}

                {isAcceptSubmissioDataAllowed && (
                  <ActionButton
                    signetSignal={true}
                    actionMessage={Tooltips.approve}
                    action={() =>
                      this.handleUpdateSignetStatus(
                        signetStatuses.FINISHED.name
                      )
                    }
                    icon={
                      <DoneAllIcon
                        fontSize="large"
                        style={{ color: '#203a5d' }}
                      />
                    }
                  />
                )}
                {isRequestForSignetStatusCreateAllowed && (
                  <ActionButton
                    signetSignal={true}
                    actionMessage={Tooltips.requestForSignetStatus}
                    action={() => this.showModal(6)}
                    icon={
                      <CreateNewFolderOutlinedIcon
                        fontSize="large"
                        style={{ color: '#203a5d' }}
                      />
                    }
                  />
                )}
                {isRequestForSignetStatusValidateAllowed &&
                  !this.props.requestForSignetStatus.valid && (
                    <ActionButton
                      signetSignal={true}
                      actionMessage={Tooltips.acceptRequestForSignetStatus}
                      action={this.acceptRequestForSignetStatus}
                      icon={
                        <BeenhereRoundedIcon
                          fontSize="large"
                          style={{ color: '#203a5d' }}
                        />
                      }
                    />
                  )}
                <ActionButton
                  signetSignal={true}
                  actionMessage={Tooltips.complementationHistory}
                  action={() => this.showModal(9)}
                  icon={
                    <HistoryRoundedIcon
                      fontSize="large"
                      style={{ color: '#203a5d' }}
                    />
                  }
                />
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col md={7} className="mt-5">
          <Card>
            <Card.Header>
              <Card.Title as="h5">{t.Labels.documentTitle}</Card.Title>
            </Card.Header>
            <Card.Body style={{ marginTop: '-30px' }}>
              <AttachmentTable
                attachments={attachments}
                handleDownload={downloadAttachment}
                controllerReference={'requestForSignetApprovalAttachment'}
              />
            </Card.Body>
          </Card>
        </Col>
        {!(
          Object.keys(this.props.requestForSignetStatusAttachment).length === 0
        ) && (
          <Col md={7} className="ml-auto">
            <Card>
              <Card.Header>
                <Card.Title as="h5">
                  {t.Labels.requestForSignetStatusTitle}
                </Card.Title>
              </Card.Header>
              <Card.Body style={{ marginTop: '-30px' }}>
                <AttachmentTable
                  attachments={requestStatusAttachment}
                  handleDownload={downloadAttachment}
                  controllerReference={'requestForSignetApprovalAttachment'}
                />
              </Card.Body>
            </Card>
          </Col>
        )}
      </Row>
    );

    const pageContent = (
      <div className="col-md-11 m-auto">
        <Row>
          <Col md={12}>
            <Card className="mt-5">
              <Card.Header>
                <Row>
                  <Col md={5}>
                    <Card.Title as="h5">{t.Labels.title}</Card.Title>
                  </Col>
                  <Col className="text-center">
                    <Card.Title className="row align-items-center">
                      <Col md={5} disabled className="preview-style ml-auto">
                        {signetStatusInfo}
                      </Col>
                      {signetState && (
                        <Col md={4} disabled className="preview-style">
                          {signetStateInfo}
                        </Col>
                      )}
                    </Card.Title>

                    {signet.signetState === 'READY_TO_USE' && (
                      <Col md={8} className="info-blue-color bold ml-auto">
                        <label className="faded-text fileName labelText ml-auto mb-auto">
                          {t.Placeholders.notificationStartFrom +
                            numberOfDaysUntilStart +
                            numberOfDaysUntilStartText}
                        </label>
                      </Col>
                    )}
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body>{signetData}</Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );

    return (
      <Fragment>
        {pageContent}
        {this.state.showComplementSignet && (
          <ModalForAddComplementSignet
            show={this.state.showComplementSignet}
            handleClose={this.handlePreviewClose}
            signet={this.props.signet}
            handleAdd={this.handleAddComplementSignet}
            loggedUser={this.props.loggedUser}
            error={errorComplement}
          />
        )}
        {this.state.showComplementSignetDesc && (
          <ModalForAddComplementSignet
            show={this.state.showComplementSignetDesc}
            handleClose={this.handlePreviewClose}
            signet={this.props.signet}
            handleAdd={this.handleAddComplementSignet}
            findLastComplementSignetBySignetId={
              this.props.findLastComplementSignetBySignetId
            }
            signal={true}
            complementSignet={this.props.complementSignet}
            error={errorComplement}
          />
        )}
        {this.state.showSubmissionDataSignet && (
          <ModalForAddSubmissionDataSignet
            show={this.state.showSubmissionDataSignet}
            signet={signet}
            submissionDataSignetLookAttachment={
              submissionDataSignetLookAttachment
            }
            submissionDataSignetDestroyedAttachment={
              submissionDataSignetDestroyedAttachment
            }
            handleClose={this.handlePreviewClose}
            handleAdd={this.handleAdd}
            handleAddWithLook={this.handleAddWithLook}
            error={this.props.error}
          />
        )}
        {this.state.showRequestForSignetStatus && (
          <ModalForAddRequestForSignetStatus
            show={this.state.showRequestForSignetStatus}
            handleClose={this.handlePreviewClose}
            handleAdd={this.handleAddRequestForSignetStatus}
            signet={signet}
          />
        )}
        {this.state.showRequestForSignetApprovalPreview && (
          <ModalForPreviewRequestApproval
            show={this.state.showRequestForSignetApprovalPreview}
            handleClose={this.handlePreviewClose}
            id={signet?.decision?.requestForSignetApproval?.id}
          />
        )}
        {this.state.showModalForSignetDestroyedAttachment && (
          <ModalForUploadSignetDestroyedAttachment
            show={this.state.showModalForSignetDestroyedAttachment}
            handleClose={this.handlePreviewClose}
            handleUpload={this.handleUploadSignetDestroyedAttachment}
            handleAddWithLook={this.handleAddWithLook}
            error={this.props.error}
          />
        )}
        {this.state.showComplementSignetHistory && (
          <ModalForViewComplementSignetHistory
            show={this.state.showComplementSignetHistory}
            handleClose={this.handlePreviewClose}
            complementSignetList={complementSignetList}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  signet: state.signet.signet,
  submissionDataSignet: state.submissionDataSignet,
  submissionDataSignetDestroyed: state.submissionDataSignetDestroyed,
  submissionDataSignetLook: state.submissionDataSignetLook,
  complementSignet: state.complementSignet.complementSignet,
  complementSignetList: state.complementSignet.complementSignetList || [],
  errorComplement: state.complementSignet.error,
  loggedUser: state.loggedUser.loggedUser,
  userAllowedActionsList: state.user.userAllowedActionsList || [],
  requestForSignetStatusAttachment:
    state.requestForSignetStatusAttachment.requestForSignetStatusAttachment ||
    {},
  requestForSignetStatus:
    state.requestForSignetStatus.requestForSignetStatus || {},
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllUserAllowedActions: (signetId, controllerReference) => {
      dispatch(findAllUserAllowedActions(signetId, controllerReference));
    },
    createSubmissionDataSignet: (submissionDataSignet, callback, message) => {
      dispatch(
        createSubmissionDataSignet(submissionDataSignet, callback, message)
      );
    },
    createSubmissionDataSignetWithLook: (
      submissionDataSignet,
      callback,
      messages,
      signetStatusEnums,
      signetStatus
    ) => {
      dispatch(
        createSubmissionDataSignetWithLook(
          submissionDataSignet,
          callback,
          messages,
          signetStatusEnums,
          signetStatus
        )
      );
    },
    findSubmissionDataSignetBySignetId: (signetId) => {
      dispatch(findSubmissionDataSignetBySignetId(signetId));
    },
    findSignetById: (id) => {
      dispatch(findSignetById(id));
    },
    findSubmissionDataSignetDestroyedLatestVersione: (
      submissionDataSignetId
    ) => {
      dispatch(
        findSubmissionDataSignetDestroyedLatestVersione(submissionDataSignetId)
      );
    },
    deleteLookContetnt: () => {
      dispatch(deleteLookContetnt());
    },
    deleteDestroyedContetnt: () => {
      dispatch(deleteDestroyedContetnt());
    },
    updateSignetStatus: (id, status, callback, messages) => {
      dispatch(updateSignetStatus(id, status, callback, messages));
    },
    updateSignetState: (id, signetState, callback) => {
      dispatch(updateSignetState(id, signetState, callback));
    },
    clearComplementSignet: () => {
      dispatch(clearComplementSignet());
    },
    findLastComplementSignetBySignetId: (signetId) => {
      dispatch(findLastComplementSignetBySignetId(signetId));
    },
    findComplementSignetListBySignetId: (signetId) => {
      dispatch(findComplementSignetListBySignetId(signetId));
    },
    findRequestForSignetStatusBySignetId: (signetId) => {
      dispatch(findRequestForSignetStatusBySignetId(signetId));
    },
    createComplementSignet: (signet, callback, message) => {
      dispatch(createComplementSignet(signet, callback, message));
    },
    downloadAttachment: (uuidDocName, documentName) => {
      dispatch(downloadAttachment(uuidDocName, documentName));
    },
    createRequestForSignetStatus: (
      requestForSignetStatus,
      callback,
      callback2,
      message,
      callback3
    ) => {
      dispatch(
        createRequestForSignetStatus(
          requestForSignetStatus,
          callback,
          callback2,
          message,
          callback3
        )
      );
    },
    validateRequestForSignetStatus: (
      requestForSignetStatusId,
      callback,
      messages,
      callback2
    ) => {
      dispatch(
        validateRequestForSignetStatus(
          requestForSignetStatusId,
          callback,
          messages,
          callback2
        )
      );
    },
    downloadExample: (messages) => {
      dispatch(downloadExample(messages));
    },
    uploadSubmissionDataSignetDestroyed: (
      signetDestroyedData,
      submissionDataSignetId,
      callback,
      notificationMessage
    ) => {
      dispatch(
        uploadSubmissionDataSignetDestroyed(
          signetDestroyedData,
          submissionDataSignetId,
          callback,
          notificationMessage
        )
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(SignetProcessingView, 'SignetProcessingView'));
